import type {Mapper} from 'framework';
import type {SavedMealSummary} from '../../domain/saved-meal';
import type {SavedMealListDto} from '../dto/saved-meal.dto';

type ListSuccess = Extract<SavedMealListDto, {data: readonly unknown[]}>;
type SummaryDto = ListSuccess['data'][number];

export class SavedMealSummaryDtoToSummaryMapper implements Mapper<SummaryDto, SavedMealSummary> {
  transform(dto: SummaryDto): SavedMealSummary {
    return {
      id: dto.id,
      name: dto.name,
      description: dto.description,
      lineCount: dto.lineCount,
      totalKcal: dto.totalKcal,
      totalProteinGrams: dto.totalProteinGrams,
      totalCarbsGrams: dto.totalCarbsGrams,
      totalFatGrams: dto.totalFatGrams,
      createdAt: String(dto.createdAt),
      updatedAt: String(dto.updatedAt),
      lastTouchedAt: String(dto.lastTouchedAt),
    };
  }
}
